const MagicPen = ({ width = 20, height = 20, color = 'currentColor' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 20 20" fill="none">
      <path
        d="M3.27016 16.7288C3.92724 17.3859 4.98807 17.3859 5.64516 16.7288L15.9368 6.43715C16.5939 5.78007 16.5939 4.71923 15.9368 4.06215C15.2797 3.40507 14.2189 3.40507 13.5618 4.06215L3.27016 14.3538C2.61307 15.0109 2.61307 16.0717 3.27016 16.7288Z"
        stroke={color}
        strokeWidth="1.09615"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.7578 7.61719L12.3828 5.24219"
        stroke={color}
        strokeWidth="1.09615"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.23047 2.43183L8.41797 2.0835L8.06964 3.271L8.41797 4.4585L7.23047 4.11016L6.04297 4.4585L6.3913 3.271L6.04297 2.0835L7.23047 2.43183Z"
        stroke={color}
        strokeWidth="1.09615"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.0625 7.18183L5.25 6.8335L4.90167 8.021L5.25 9.2085L4.0625 8.86016L2.875 9.2085L3.22333 8.021L2.875 6.8335L4.0625 7.18183Z"
        stroke={color}
        strokeWidth="1.09615"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.9375 11.1398L17.125 10.7915L16.7767 11.979L17.125 13.1665L15.9375 12.8182L14.75 13.1665L15.0983 11.979L14.75 10.7915L15.9375 11.1398Z"
        stroke={color}
        strokeWidth="1.09615"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default MagicPen;
